import React from 'react';
import imgCao from '../assets/cao-comendo.png'; 

const ModoUso = () => {
  const dosagens = [
    { weight: "Até 10 KG", amount: "1 Gummy", icons: 1 },
    { weight: "10-20 KG", amount: "2 Gummies", icons: 2 },
    { weight: "20-30 KG", amount: "3 Gummies", icons: 3 },
    { weight: "+30 KG", amount: "4 Gummies", icons: 4 }
  ];

  const renderBones = (count) => {
    let bones = [];
    for (let i = 0; i < count; i++) {
      bones.push(
        <span key={i} style={{fontSize: '1.4rem', margin: '0 2px'}}>
          🦴
        </span>
      );
    }
    return bones;
  };

  return (
    <section style={{padding: '40px 20px', backgroundColor: '#F5F9F6', textAlign: 'center', overflow: 'hidden'}}>
      <div className="container" style={{maxWidth: '1100px', margin: '0 auto', position: 'relative'}}>
        
        <h2 style={{
          color: '#397449', 
          fontSize: '2.5rem', 
          fontWeight: '900', 
          marginBottom: '10px', 
          textTransform: 'uppercase',
          position: 'relative', zIndex: 1
        }}>
          Sugestão de Consumo
        </h2>
        
        <p style={{
            fontSize: '1.1rem', 
            color: '#666', 
            marginBottom: '40px', 
            maxWidth: '700px', 
            margin: '0 auto 40px', 
            fontFamily: '"Commissioner", sans-serif',
            position: 'relative', zIndex: 1
        }}>
          Tão gostoso que parece petisco, mas é saúde. Ofereça diariamente:
        </p>

        <div style={styles.mainContentGrid}>
            
            <div style={styles.imageWrapper}>
                <img 
                    src={imgCao}
                    alt="Cão comendo Gummy"
                    style={styles.heroImage}
                />
            </div>

           
            <div style={styles.dosageGrid}>
                {dosagens.map((item, index) => (
                    <div key={index} style={styles.dosageCard}>
                        {/* Peso */}
                        <div style={styles.badgePeso}>
                            {item.weight}
                        </div>
                        
                        <h3 style={{
                            color: '#5D2E8C', 
                            fontWeight: '900', 
                            fontSize: '1.4rem', 
                            margin: '10px 0 5px 0',
                        }}>
                            {item.amount}
                        </h3>
                        
                        {/* Ossinhos Laranjas */}
                        <div style={{color: '#DB6533'}}>
                            {renderBones(item.icons)}
                        </div>
                    </div>
                ))}
            </div>
        </div>

        {/* BOTÃO LARANJA (Cor oficial de CTA) */}
        <div style={{marginTop: '50px', position: 'relative', zIndex: 1}}>

            <p style={{fontSize: '0.85rem', color: '#888', marginTop: '15px', fontFamily: '"Commissioner", sans-serif'}}>
                *Compra 100% segura. Envio imediato para todo o Brasil.
            </p>
        </div>

      </div>
    </section>
  );
};

const styles = {
    mainContentGrid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '40px',
        flexWrap: 'wrap', 
        position: 'relative', zIndex: 1
    },
    imageWrapper: {
        flex: '1 1 300px', 
        maxWidth: '400px',
        position: 'relative'
    },
    heroImage: {
        width: '100%',
        borderRadius: '20px', 
        boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
        border: '4px solid #fff',
        objectFit: 'cover'
    },
    dosageGrid: {
        flex: '1 1 500px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', 
        gap: '15px'
    },
    dosageCard: {
        backgroundColor: '#fff',
        padding: '20px 10px',
        borderRadius: '20px',
        boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
        border: '2px solid #E0E0E0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    badgePeso: {
        backgroundColor: '#397449', // VERDE OFICIAL
        color: '#fff',
        padding: '5px 12px',
        borderRadius: '20px',
        fontSize: '0.8rem',
        fontWeight: 'bold',
        fontFamily: '"Commissioner", sans-serif'
    },
    buyButton: {
        backgroundColor: '#DB6533', // LARANJA OFICIAL (Destaque)
        color: '#fff',
        border: 'none',
        padding: '18px 30px',
        borderRadius: '50px',
        fontWeight: 'bold',
        fontSize: '1rem',
        cursor: 'pointer',
        boxShadow: '0 10px 20px rgba(219, 101, 51, 0.4)',
        fontFamily: '"Commissioner", sans-serif',
        textTransform: 'uppercase',
        transition: 'transform 0.2s',
        width: '100%',
        maxWidth: '450px'
    }
};

export default ModoUso;